module.exports = __webpack_public_path__ + "static/img/s48.f61f24e9.png";